import { render, staticRenderFns } from "./gem.vue?vue&type=template&id=2964e809&"
import script from "./gem.vue?vue&type=script&lang=js&"
export * from "./gem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports